import React from 'react';
import { string } from 'prop-types';
import i18next from 'i18next';

import { snakeToCamel } from '~utils/string';

import styles from '../../styles.module.scss';
import { MERCAT_CHANNEL } from '../../../ChannelInfo/constants';
import { ChannelInfo } from '../../../ChannelInfo';

function PaymentMethod({ channel, paymentMethod, paymentMessage }) {
  return (
    <div className={`m-top-1 m-left-2 m-right-2 ${styles.border}`}>
      <div className="row middle space-between">
        <div className="row middle">
          <div className={styles.clientTitle}>
            <span className="bold font-size-14">{i18next.t('OrdersDetails:paymentMethod')}</span>
          </div>
          <div>
            <span className="font-size-14">
              {channel !== MERCAT_CHANNEL ? (
                <ChannelInfo channel={snakeToCamel(channel)} showDeliveryTypeAsText />
              ) : (
                i18next.t(`OrdersDetails:${paymentMethod}`)
              )}
            </span>
          </div>
        </div>
        <span className="bold text-red-crimson font-size-14">
          {i18next.t(`OrdersDetails:${paymentMessage}`)}
        </span>
      </div>
    </div>
  );
}

PaymentMethod.propTypes = {
  channel: string.isRequired,
  paymentMessage: string.isRequired,
  paymentMethod: string.isRequired
};

export default PaymentMethod;
